import React from 'react';
import Icon from '../../../components/AppIcon';

const SubmissionChecklist = ({ 
  brandSelected,
  purchaseAmount,
  receiptUploaded,
  socialPostUrl,
  purchaseDate,
  category
}) => {
  const checklistItems = [
    {
      id: 'brand',
      label: 'Brand partner selected',
      completed: brandSelected,
      icon: 'Building2'
    },
    {
      id: 'amount',
      label: 'Purchase amount entered',
      completed: purchaseAmount,
      icon: 'DollarSign'
    },
    {
      id: 'receipt',
      label: 'Receipt uploaded',
      completed: receiptUploaded,
      icon: 'FileText'
    },
    {
      id: 'social',
      label: 'Social post URL provided',
      completed: socialPostUrl,
      icon: 'Share2'
    },
    {
      id: 'date',
      label: 'Purchase date confirmed',
      completed: purchaseDate,
      icon: 'Calendar'
    },
    {
      id: 'category',
      label: 'Product category selected',
      completed: category,
      icon: 'Tag'
    }
  ];

  const completedCount = checklistItems?.filter(item => item?.completed)?.length;
  const totalCount = checklistItems?.length;
  const progressPercentage = (completedCount / totalCount) * 100;

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground">
          Submission Checklist
        </h3>
        <span className="text-xs md:text-sm font-medium text-muted-foreground">
          {completedCount}/{totalCount}
        </span>
      </div>
      <div className="mb-4">
        <div className="h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary to-success transition-all duration-300"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
      </div>
      <div className="space-y-3">
        {checklistItems?.map((item) => (
          <div 
            key={item?.id}
            className={`flex items-center gap-3 p-3 rounded-lg transition-all ${
              item?.completed 
                ? 'bg-success/10 border border-success/20' :'bg-muted/30 border border-border'
            }`}
          >
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
              item?.completed 
                ? 'bg-success/20' :'bg-muted'
            }`}>
              <Icon 
                name={item?.completed ? 'CheckCircle' : item?.icon} 
                size={18} 
                color={item?.completed ? 'var(--color-success)' : 'var(--color-muted-foreground)'} 
              />
            </div>
            <span className={`text-xs md:text-sm font-medium ${
              item?.completed 
                ? 'text-success' :'text-muted-foreground'
            }`}>
              {item?.label}
            </span>
          </div>
        ))}
      </div>
      {completedCount === totalCount && (
        <div className="mt-4 p-3 bg-gradient-to-r from-success/10 to-primary/10 rounded-lg border border-success/20">
          <div className="flex items-center gap-2">
            <Icon name="Sparkles" size={18} color="var(--color-success)" />
            <p className="text-xs md:text-sm text-success font-medium">
              All requirements met! Ready to submit
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubmissionChecklist;